<template>
  <div class="control-panel">
    <v-row v-for="(k, i) in ligandsLoaded" :key="k">
      <v-col>
        <v-row class="d-flex">
          <v-col>
            <v-checkbox
              v-model="checkboxes[k]"
              :label="ligands[k].name"
              @change="toggleLigand(k)"
            />
          </v-col>
          <v-col class="flex-grow-0 flex-shrink-0">
            <v-btn
              class="white--text"
              justify="right"
              color="primary"
              small
              :elevation="5"
              @click="zoomLigand(k)"
            >
              Zoom
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="checkboxes[k]">
          <v-col cols="12">
            <v-slider
              v-model="frame[k]"
              dense
              light
              :min="0"
              :max="ligands[k].numframes - 1"
              show-input
              @input="setFrame(k, $event)"
            />
          </v-col>
        </v-row>
        <v-row v-if="checkboxes[k]" style="font-size: 12px">
          <v-col cols="8" class="text-right lgfe_title">
            LGFE (kcal/mol):
          </v-col>
          <v-col cols="4" class="text-right align-right d-flex justify-end">
            <div class="accent white--text px-1 rounded-pill lgfe">
              {{ getLGFE(ligands[k].name, frame[k]) }}
            </div>
          </v-col>
        </v-row>
        <!-- <v-row>
          {{ checkboxes[k] }}
        </v-row> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "Mcligand",
  computed: {
    ligandsLoaded() {
      console.log("ligandsLoaded...", this.checkboxes);
      return this.$store.state.mcligands_loaded;
    },
    ligands() {
      return this.$store.state.mcligands_available;
    },
  },
  mounted() {},
  data() {
    return {
      checkboxes: {},
      frame: {},
    };
  },
  methods: {
    getLGFE(ligand_name, frame_index) {
      console.log("ligand_name, frame_index", ligand_name, frame_index);
      const ligands = this.$store.state.current_project.ligands;
      console.log("ligands", ligands);
      const lgfe = ligands.find((o) => o.name === ligand_name).lgfe;
      console.log("lgfe", lgfe);
      if (lgfe[frame_index]) return lgfe[frame_index].toFixed(2);
      else return "";
    },
    toggleLigand(ligandname) {
      this.$store.dispatch("toggleMCLigand", { ligandname: ligandname });
    },
    zoomLigand(ligandname) {
      this.$store.dispatch("zoomMCLigand", { ligandname: ligandname });
    },
    setFrame(ligandname, framenum) {
      this.$store.dispatch("setFrame", {
        ligandname: ligandname,
        frame: framenum,
      });
    },
  },
};
</script>

<style scoped>
button {
  height: 21px;
  width: 55px;
}
.lgfe_title {
  color: #140842;
}
.lgfe {
  width: 60px;
  text-align: center;
}
</style>
